const DEFAULT_API_BASE_URL = "https://api.superceuticals.in";
// const DEFAULT_API_BASE_URL = "https://qa.sc.superceuticals.in";


// const DEFAULT_API_BASE_URL = "http://localhost:2001/"
/**
 * Shared API base URL that can be overridden via REACT_APP_API_BASE_URL.
 * Falls back to the production URL to avoid breaking existing builds.
 */

export const API_BASE_URL =
  (process.env.REACT_APP_API_BASE_URL &&
    process.env.REACT_APP_API_BASE_URL.trim()) ||
  DEFAULT_API_BASE_URL;

export default API_BASE_URL;
